import { useSelector } from 'react-redux'
import { DatasetDeterminationConstants, IConfigurationsState } from '../../configurations/store/configurations.types'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { IPickupAddressState } from '../../pickupAddress/store/pickupAddress.types'
import { getPickupAddressSelector } from '../../pickupAddress/selectors'
import { getDestinationAddressSelector } from '../../destinationAddress/selectors/destinationAddress.selectors'
import { IDispositionState } from '../../destinationAddress/store/destinationAddress.types'

const useCheckToDisableBasedOnCustomStateRules = () => {
  const { datasetDeterminationConfig }: IConfigurationsState = useSelector(getConfigurationsSelector)

  const { base, unit }: ITripInformationState = useSelector(getTripInformationSelector)
  const { state: pickupState }: IPickupAddressState = useSelector(getPickupAddressSelector)

  const {
    destination: { state: destinationState },
  }: IDispositionState = useSelector(getDestinationAddressSelector)

  if (!datasetDeterminationConfig) {
    return false
  }

  if (datasetDeterminationConfig?.activateNemsis === 0) {
    return false
  }

  let datasetVal = '',
    dataSetValSecondary = ''

  switch (datasetDeterminationConfig?.datasetDetermination) {
    case DatasetDeterminationConstants.BY_DEFAULT_DATASET:
      datasetVal = datasetDeterminationConfig?.defaultDataset || ''
      break
    case DatasetDeterminationConstants.BY_BASE_SITE:
      datasetVal = base?.state || ''
      break
    case DatasetDeterminationConstants.BY_UNIT_STATE:
      datasetVal = unit?.state || ''
      break
    case DatasetDeterminationConstants.BY_REF_STATE:
      datasetVal = pickupState?.id?.toString() || ''
      break
    case DatasetDeterminationConstants.BY_REC_STATE:
      datasetVal = destinationState?.id?.toString() || ''
      break
    case DatasetDeterminationConstants.BY_REF_AND_REC_STATE: {
      datasetVal = pickupState?.id?.toString() || ''
      dataSetValSecondary = destinationState?.id?.toString() || ''
      break
    }
    case DatasetDeterminationConstants.BY_BASE_SITE_REGION:
      datasetVal = base?.regionState || ''
      break
  }

  const datasetArr = datasetDeterminationConfig?.datasets ?? []
  const findFirstRelevantDataSet = datasetArr.findIndex((dtSet) => dtSet.dataset === datasetVal.toString())
  const findSecondRelevantDataSet = datasetArr.findIndex((dtSet) => dtSet.dataset === dataSetValSecondary.toString())

  if (datasetDeterminationConfig?.datasetDetermination === DatasetDeterminationConstants.BY_REF_AND_REC_STATE) {
    if (findFirstRelevantDataSet >= 0 && findSecondRelevantDataSet >= 0) {
      if (
        datasetArr[findFirstRelevantDataSet].isStateSupportedInNOW === 1 &&
        datasetArr[findSecondRelevantDataSet].isStateSupportedInNOW === 1
      ) {
        return false
      }
    }

    if (findFirstRelevantDataSet >= 0 && !dataSetValSecondary) {
      if (datasetArr[findFirstRelevantDataSet].isStateSupportedInNOW === 1) {
        return false
      }
    }
    if (findSecondRelevantDataSet >= 0 && !datasetVal) {
      if (datasetArr[findSecondRelevantDataSet].isStateSupportedInNOW === 1) {
        return false
      }
    }
    return true
  }

  if (findFirstRelevantDataSet >= 0 && datasetArr[findFirstRelevantDataSet].isStateSupportedInNOW === 1) {
    return false
  }

  return true
}
export default useCheckToDisableBasedOnCustomStateRules
